import { create } from 'zustand'

type OnboardingState = {
  /**
   * Bumped by the sidebar's replay button. A counter rather than a boolean so
   * pressing it twice in a row starts the tour twice.
   */
  startRequest: number
  start: () => void
}

export const useOnboardingTour = create<OnboardingState>(set => ({
  startRequest: 0,
  start: () => set(state => ({ startRequest: state.startRequest + 1 }))
}))
